import { ReservationForm } from '@/types';
import { format } from 'date-fns';

export function formatTo12Hour(time24: string): string {
    const [hourString, minute] = time24.split(':');
    const hour24 = parseInt(hourString, 10);
    const period = hour24 >= 12 ? 'PM' : 'AM';
    const hour12 = (hour24 % 12 || 12).toString();
    return `${hour12}:${minute} ${period}`;
}

export const HOURS_24 = Array.from(
    { length: 24 },
    (_, i) => `${String(i).padStart(2, '0')}:00`,
);

export const availableEnd = (
    data: ReservationForm,
    reservedHours: string[],
) => {
    const start = data.start_time;
    if (!start) return [];

    const startIndex = HOURS_24.indexOf(start);
    const result: string[] = [];

    // 1️⃣ Same day (after start time)
    for (let i = startIndex + 1; i < HOURS_24.length; i++) {
        const time = HOURS_24[i];

        if (reservedHours.includes(time)) {
            result.push(time);
            return result;
        }

        result.push(time);
    }

    // 2️⃣ Next day (from 00:00 → until reserved)
    for (let i = 0; i <= startIndex; i++) {
        const time = HOURS_24[i];

        if (reservedHours.includes(time)) {
            result.push(time);
            return result;
        }

        result.push(time);
    }

    return result;
};

export function buildStartEnd(date: string, start: string, end: string) {
    const startDate = date;

    // if end time is smaller than start time → next day
    const isNextDay = end <= start;

    const endDate = isNextDay
        ? format(
              new Date(new Date(date).setDate(new Date(date).getDate() + 1)),
              'yyyy-MM-dd',
          )
        : date;

    return {
        start: {
            date: startDate,
            time: start,
        },
        end: {
            date: endDate,
            time: end,
        },
    };
}
